export default __webpack_public_path__ + "static/media/Filament of Nightmare.b8a1eeac.jpg";